



































import Vue from 'vue';
import AppBar from '@/components/AppBar.vue';

export default Vue.extend({
  components: {
    AppBar,
  },
  props: {
    title: String,
    idType: String,
    description: String,
  },
  data(): { spaceId: string } {
    return {
      spaceId: '',
    };
  },
  computed: {
    dangerouslyEscapedSpaceId(): string {
      return this.spaceId
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    },
  },
  methods: {
    async createSpace(): Promise<any> {
      const spaceId = await this.$store
        .dispatch('createSpace', { spaceId: this.spaceId })
        .catch((err) => {
          console.log(err);
          // TODO: Show already used
          return '';
        });
      this.$router.push({ path: `/${spaceId}` });
    },
  },
});
